import type { MaterialInfo, MaterialValue } from '@rogue/rackbuilder'
import type { CaveOptions, RackOptions } from '../../../RackTypes'
import { BaseMaterialStrategy } from './strategies/baseMaterialStrategy'
import { RMLMaterialStrategy } from './strategies/rmlMaterialStrategy'
import { RMMaterialStrategy } from './strategies/rmMaterialStrategy'

// Main material builder - delegates to RM or RML strategies
export class MaterialBuilder {
  protected strategy: BaseMaterialStrategy
  
  constructor(config: RackOptions | CaveOptions) {
    // Choose strategy based on line
    this.strategy = config.line === 'RM' 
      ? new RMMaterialStrategy(config as RackOptions)
      : new RMLMaterialStrategy(config as RackOptions)
  }
  
  // Delegate all methods to the strategy
  createMainMaterial(): MaterialInfo {
    return this.strategy.createMainMaterial()
  }

  createMainMaterialValue(): MaterialValue {
    return this.strategy.createMainMaterialValue()
  }

  // For crossmembers (can differ from uprights e.g. txtGray)
  createCrossmemberMaterials(): MaterialInfo {
    return this.strategy.createCrossmemberMaterials()
  }

  createWideCrossmemberMaterials(): MaterialInfo {
    return this.strategy.createWideCrossmemberMaterials()
  }
  
  createAddonMaterials(): MaterialInfo {
    return this.strategy.createAddonMaterials()
  }

  createFrontCrossmemberAddonMaterials(): MaterialInfo {
    return this.strategy.createFrontCrossmemberAddonMaterials()
  }
  
  createNameplateMaterials(nameplateOverride?: MaterialInfo, backOverride?: RackOptions['back']): MaterialInfo {
    return this.strategy.createNameplateMaterials(nameplateOverride, backOverride)
  }
  
  createBackCrossmemberMaterials(backOverride?: RackOptions['back'], topCrossmemberOverride?: MaterialInfo): MaterialInfo {
    return this.strategy.createBackCrossmemberMaterials(backOverride, topCrossmemberOverride)
  }
  
  createBackStabilizerMaterials(): MaterialInfo {
    return this.strategy.createBackStabilizerMaterials()
  }
  
  createFrontCrossmemberMaterials(frontCrossmemberOverride?: MaterialInfo): MaterialInfo {
    return this.strategy.createFrontCrossmemberMaterials(frontCrossmemberOverride)
  }
  
  createSocketPullupMaterials(color: string, knurl?: string): MaterialInfo {
    return this.strategy.createSocketPullupMaterials(color, knurl)
  }
  
  createCrownMaterials(): MaterialInfo {
    return this.strategy.createCrownMaterials()
  }
  
  createMiddleOptionMaterials(): MaterialInfo {
    return this.strategy.createMiddleOptionMaterials()
  }
}